import { render, staticRenderFns } from "./PWASuggestion.vue?vue&type=template&id=3c60a039&scoped=true&"
import script from "./PWASuggestion.vue?vue&type=script&lang=js&"
export * from "./PWASuggestion.vue?vue&type=script&lang=js&"
import style0 from "./PWASuggestion.vue?vue&type=style&index=0&id=3c60a039&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c60a039",
  null
  
)

export default component.exports